/* SATRI header search panel: top searches + live product rail. */
(function () {
  if (window.__satriSearchPanel) return;
  window.__satriSearchPanel = true;

  var cache = {};

  function searchUrl(q) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var base = root + 'search';
    return base + '?q=' + encodeURIComponent(q) +
      '&type=product&options%5Bprefix%5D=last&section_id=satri-search-panel';
  }

  function load(q) {
    var key = q.toLowerCase();
    if (!cache[key]) {
      cache[key] = fetch(searchUrl(q), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var inner = doc.querySelector('.satri-sp__inner');
          return inner ? inner.innerHTML : '';
        })
        .catch(function () {
          delete cache[key];
          return null;
        });
    }
    return cache[key];
  }

  function setup(panel) {
    if (panel.__satriReady) return;
    panel.__satriReady = true;

    var modal = panel.closest('.search-modal');
    var details = panel.closest('details');
    var content = panel.closest('.search-modal__content');
    var input = modal && modal.querySelector('input[name="q"]');
    var out = panel.querySelector('[data-satri-sp-results]');
    var chips = Array.prototype.slice.call(panel.querySelectorAll('[data-term]'));
    if (!modal || !details || !input || !out) return;

    var defaultTerm = chips.length ? chips[0].getAttribute('data-term') : '';
    var current = null;
    var seq = 0;
    var timer;

    function mark(term) {
      var t = (term || '').toLowerCase();
      chips.forEach(function (c) {
        var on = c.getAttribute('data-term').toLowerCase() === t;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function show(q) {
      if (!q || q === current) return;
      current = q;
      var mine = ++seq;
      panel.classList.add('is-loading');
      load(q).then(function (html) {
        if (mine !== seq) return;
        panel.classList.remove('is-loading');
        if (html === null) { current = null; return; }
        out.innerHTML = html;
        var track = out.querySelector('.satri-sp__track');
        if (track) track.scrollLeft = 0;
      });
    }

    function fit() {
      if (!content) return;
      var top = modal.getBoundingClientRect().top;
      var h = Math.max(240, window.innerHeight - Math.max(0, top));
      content.style.maxHeight = h + 'px';
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var t = c.getAttribute('data-term');
        input.value = t;
        mark(t);
        show(t);
      });
    });

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var q = input.value.trim();
        if (q.length < 2) {
          mark(defaultTerm);
          show(defaultTerm);
          return;
        }
        mark(q);
        show(q);
      }, 260);
    });

    function onOpen() {
      if (!details.open) return;
      fit();
      if (current === null) {
        var q = input.value.trim();
        if (q.length < 2) q = defaultTerm;
        mark(q);
        show(q);
      }
    }

    details.addEventListener('toggle', onOpen);
    window.addEventListener('resize', function () { if (details.open) fit(); });

    var summary = details.querySelector('summary');
    if (summary && defaultTerm) {
      var warm = function () { load(defaultTerm); };
      summary.addEventListener('pointerenter', warm, { once: true });
      summary.addEventListener('touchstart', warm, { once: true, passive: true });
      summary.addEventListener('focus', warm, { once: true });
    }

    onOpen();
  }

  function init() {
    document.querySelectorAll('[data-satri-sp]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
